module.exports = __webpack_public_path__ + "img/icon-home-white.20e64e33.svg";